<template>
  <div class="all">
    <div class="nav" :style="getBgTmd()">
      <div class="ital-logo">
        <img :src="fileServerUrl + 'assets/images/iTALLlogo.png'" />
      </div>
      <div class="dhl">
        <div class="hvr-underline-from-center">
          <a href="http://www.huiyuexpo.com/#/">
            <span class="under-line menu hvr-underline-from-center">{{
              $t("organizer")
            }}</span>
          </a>
        </div>
        <div class="hvr-underline-from-center">
          <router-link to="/">
            <span
              class="under-line menu hvr-underline-from-center"
              :class="{ 'menu-active': menuIndex == 1 }"
              >{{ $t("home") }}</span
            >
          </router-link>
        </div>

        <div class="dropdown">
          <span
            style="cursor: pointer"
            class="menu hvr-underline-from-center"
            :class="{ 'menu-active': menuIndex == 2 }"
            >{{ $t("meeting") }}</span
          >

          <div
            class="dropdown-content2"
            :class="{ 'menu-active': menuIndex == 2 }"
          >
            <router-link
              to="/Meeting"
              class="menu"
              :class="{ 'menu-active': menuIndex == 2 }"
              ><p>{{ $t("meeting") }}</p></router-link
            >
            <!-- <router-link
              to="/agenda"
              class="menu"
              :class="{ 'menu-active': menuIndex == 2 }"
              ><p>{{ $t("agenda") }}</p></router-link
            > -->
          </div>
        </div>

        <div class="dropdown">
          <span
            style="cursor: pointer"
            class="menu hvr-underline-from-center"
            :class="{ 'menu-active': menuIndex == 3 }"
            >{{ $t("sponsorship_exhibitions") }}</span
          >

          <div
            class="dropdown-content1"
            :class="{ 'menu-active': menuIndex == 3 }"
          >
            <router-link
              to="/whysponsor"
              class="menu"
              :class="{ 'menu-active': menuIndex == 3 }"
              ><p>{{ $t("why_sponsor") }}</p></router-link
            >
            <router-link
              to="/exibitions"
              class="menu"
              :class="{ 'menu-active': menuIndex == 3 }"
              ><p>{{ $t("sponsors_exhibitors") }}</p></router-link
            >
          </div>
        </div>
        <!-- <div class="hvr-underline-from-center">
          <router-link to="/awards">
            <span class="menu" :class="{ 'menu-active': menuIndex == 4 }">{{
              $t("awards")
            }}</span>
          </router-link>
        </div> -->
        <div class="dropdown">
          <span
            style="cursor: pointer"
            class="menu hvr-underline-from-center"
            :class="{ 'menu-active': menuIndex == 5 }"
            >{{ $t("enroll") }}</span
          >
          <div class="dropdown-content2">
            <router-link
              to="/hyticket"
              class="menu"
              :class="{ 'menu-active': menuIndex == 5 }"
              ><p>{{ $t("conference_pass") }}</p></router-link
            >
            <router-link
              to="/freeticket"
              class="menu"
              :class="{ 'menu-active': menuIndex == 5 }"
              ><p>{{ $t("free_tickets") }}</p></router-link
            >
          </div>
        </div>
        <i
          @click="changeLang"
          class="iconfont icon-diqiu3"
          style="
            cursor: pointer;
            font-size: 0.11rem;
            margin-right: 2%;
            color: red;
            font-weight: bold;
          "
        ></i>
        <!-- <div style="width: 120px">
          <router-link
            to=""
            class="menu"
            :class="{ 'menu-active': menuIndex == 6 }"
          >
            <span>
              <i
                class="iconfont icon-diqiu3"
                style="
                  font-size: 0.11rem;
                  margin-right: 2%;
                  color: red;
                  font-weight: bold;
                "
              ></i>
              简体中文
            </span>
          </router-link>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["menuIndex"],
  name: "MyHeader",
  data() {
    return {
      fileServerUrl: fileServerUrl,
      tmd: 0,
      flag: true,
    };
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    changeLang() {
      if (this.flag == true) {
        this.$i18n.locale = "en";
        this.flag = !this.flag;
      } else {
        this.$i18n.locale = "zh";
        this.flag = !this.flag;
      }
    },
    getBgTmd() {
      return {
        backgroundColor: "rgba(255, 255, 255, " + this.tmd + ")",
      };
    },
    handleScroll(e) {
      this.currentScroll = window.pageYOffset; //表示当前滚动的位置
      this.tmd = this.currentScroll / 250.0;
    },
  },
};
</script>

<style lang="scss" scoped>
/*  @media all and (max-width: 900px) {
        .dhl{
            width: 50% !important;
            display: flex !important;
            justify-content: space-between !important;
        }
    }*/
.all {
  width: 100%;
  height: 40px;
  //border: 0.1px solid red;
  font-size: 0.1rem;
  position: fixed;
  z-index: 222;
  font-family: "weiruan";
  color: #3b3e43;
  transition: 0.5s all;
}
.all:hover {
  background-color: #ffff;
}

.ital-logo {
  width: 40px;
  height: 15px;
  margin-left: 13.5%;
  overflow: hidden;
  //border: 0.1px solid red;
  img {
    width: 100%;
    height: 100%;
  }
}
.dhl {
  display: flex;
  width: 320px;

  //border: 0.1px solid red;
  margin-left: 26%;
  justify-content: space-between;
}

.under-line {
  border-bottom: 2px red;
}
.hvr-underline-from-center:before {
  background: red;
}

.nav {
  display: flex;
  height: 38px;
  align-items: center;
  background-color: white;
  color: #656565;
}

.dropdown-content1 {
  text-align: center;
  width: 55px;
  height: 40px;
  display: none;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.7);

  padding: 10px 12px;
  margin-left: -15px;
}

.dropdown-content2 {
  text-align: center;
  width: 45px;
  height: 40px;
  display: none;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 12px 12px;
  margin-left: -25px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown:hover .dropdown-content1 {
  display: block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.dropdown:hover .dropdown-content2 {
  display: block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.menu {
  color: #656565;
  padding-bottom: 3px;
}

.menu-active {
  color: red;
}
</style>
